import React from 'react';
import { Button } from './ui/Button';
import { ShoppingCartIcon, TruckIcon, ShieldCheckIcon } from 'lucide-react';
export function CTABlock() {
  return <div className="py-10 px-4 bg-white" data-id="element-25">
      <div className="max-w-md mx-auto text-center" data-id="element-26">
        {/* Price */}
        <div className="mb-4" data-id="element-27">
          <span className="text-sm text-[#4B5563] line-through mr-2" data-id="element-28">
            $69.990
          </span>
          <span className="text-3xl font-extrabold text-[#111827]" data-id="element-29">
            $49.990
          </span>
          <span className="ml-2 inline-block bg-[#F59E0B] text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-30">
            -29%
          </span>
        </div>

        {/* CTA Button */}
        <Button fullWidth icon={ShoppingCartIcon} className="mb-4" href="https://argrutinas.com/cart/42974027186385:1" data-id="element-31">
          Comprar Ahora – $49.990
        </Button>

        {/* Trust signals */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 text-sm text-[#4B5563]" data-id="element-32">
          <span className="flex items-center gap-1.5" data-id="element-33">
            <TruckIcon className="w-4 h-4 text-[#16A34A]" data-id="element-34" />
            Envío gratis
          </span>
          <span className="hidden sm:inline text-gray-300" data-id="element-35">|</span>
          <span className="flex items-center gap-1.5" data-id="element-36">
            <ShieldCheckIcon className="w-4 h-4 text-[#16A34A]" data-id="element-37" />
            180 días – cambio directo
          </span>
        </div>
      </div>
    </div>;
}